export default "__VITE_ASSET__C164O8T1__"